import React, {useState} from 'react';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import ProfileHeader from '../settings/PofileHeader';
import CoursesApprenticeshipTabs from "./CoursesApprenticeshipTabs";
import LearnerAchievements from './LearnerAchievements';
import ExternalCertificates from './ExternalCertificates';
import CertificatesCarousel from './CertificatesCarousel';
import Error404 from '../../../../modules/Error404';
import BreadCrumbs from '../BreadCrumbs';
import { useSelector } from 'react-redux';
import { userIcon, homeIcon } from '../../../constants/icons';

function LearnerProfile({ className }) {
  const [hasError, setHasError] = useState(false);
  const configData = useSelector((state) => state.config);
  const paths         = useSelector((state) => state.user.paths);
  const learner       = configData.session;
  const bannerImgPath = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/miscellaneous/profile-banner.webp';
  const addressObject = learner.us_address && ((learner.us_address !== '' && learner.us_address != 'null') || learner.us_address != null) ? JSON.parse(learner.us_address) : '';
  const address       = addressObject && typeof addressObject === 'object' ? Object.values(addressObject).join(', ') : 'N/A';
  
  const learnerPages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: userIcon, label: "Learner Profile" }
  ];

  if (hasError) return <Error404 />; 

  return (
    <>
    <BreadCrumbs pages={learnerPages} />
    <div className={`${className || ""} myk__stu-setting-container`}>
        <ProfileHeader
          className="mb-0"
          defaultProfileImg={paths?.user_path + learner?.us_image}
          name={learner?.us_name}
          email={learner?.us_email}
          phone={`${learner?.us_country_code} ${learner?.us_phone}`}
          location={address}
          dropdownDownloadItems={true}
          dotDropdownItems={true}
          publicProfile={false}
          profileBannerImgUrl={bannerImgPath}
        />
      <div className="myk__stu-setting-body-wrapper">
        <Row>
          <Col xl="6">
            <CertificatesCarousel setHasError={setHasError} />
            <CoursesApprenticeshipTabs setHasError={setHasError}/>
          </Col>
          <Col xl="6">
            <LearnerAchievements />
            <ExternalCertificates setHasError={setHasError}/>
          </Col>
        </Row>
      </div>
    </div>
  </>
  );
}

export default LearnerProfile;
